import { Component, OnInit, Output,EventEmitter, Input, OnChanges } from '@angular/core';
import datepickerFactory from 'jquery-datepicker';
datepickerFactory($);
@Component({
  selector: 'lib-date-picker-e11',
  templateUrl: './date-picker-e11.component.html',
  styles: []
})
export class DatePickerE11Component implements OnInit ,OnChanges {
  
  vrednost:any;
  dates = {
    year: 0,
    month: 0,
    day: 0
  };
  datepickerDynamic:any;
  @Output() dateEmitter = new EventEmitter<string>();
  @Input() datepickerDateInput:any;
  constructor() { }
  ngOnInit() {
    console.log(this.datepickerDateInput)
    this.datepickerDynamic = Math.random().toString(36).substr(2, 5);
    var id = this.datepickerDynamic;
    let self = this;
    $(function() {
      (<any>$('#'+ id)).datepicker({
        constrainInput: false,
        dateFormat : 'dd-mm-yy',
        maxDate: "-1d", 
	      minDate: new Date(self.dates.year, self.dates.month, self.dates.day),
        onSelect:(dateText)=>{
          self.dateEmitter.emit(dateText);
      }
      })
    });
  }

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    if("datepickerDateInput" in changes){
      console.log("OVA E KOA KJE SE PRATI PREKU CHILD: " , changes.datepickerDateInput.currentValue);
      let fulldate = changes.datepickerDateInput.currentValue.maxDate.split("-")
      this.dates.year = parseInt(fulldate[2]);
      this.dates.month = parseInt(fulldate[1]);
      this.dates.day = parseInt(fulldate[0]);
      console.log(this.dates)
    }
  }

  click(){
    this.vrednost = (<any>$('#' + this.datepickerDynamic))[0].value;
    this.dateEmitter.emit(this.vrednost);
  }
}
